export default "__VITE_ASSET__CflEeQgZ__"